import React, { useState } from "react";

import { useGetTasksUsage } from "api/api-hooks/airflow-hooks";
import DatasetMultiSelect from "components/basic/dropdowns/dataset/DatasetMultiSelect";
import {
  ProdTemplateDropdownItem,
  ProductTemplateMultiselect,
} from "components/basic/dropdowns/product-template-multiselect/ProductTemplateMultiselect";
import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { Button } from "primereact/button";
import { ListBox } from "primereact/listbox";
import { Link } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { AirflowSearchResult } from "types/airflow";
import { taskInputSearchResults } from "../utils/const";

type SearchUsageProps = {
  closeDialog: () => void;
};

type SearchParam = {
  datasets: string[];
  templates: ProdTemplateDropdownItem[];
};

const SearchUsage: React.FC<SearchUsageProps> = ({ closeDialog }) => {
  const [searchItems, setSearchItems] = useState<SearchParam>({ datasets: [], templates: [] });
  const { data, status, mutate: searchUsage } = useGetTasksUsage();

  const onSubmit = () => {
    searchUsage({ ...searchItems, templates: searchItems.templates.map(t => t.id) });
  };

  const itemTemplate = (item: AirflowSearchResult) => {
    const { dagId, taskId } = item.task.id;
    const searchResult = taskInputSearchResults.find(r => r.type === item.resultFound);
    return (
      <Link
        to={`/airflow/${item.task.id.dagId}/${item.task.id.taskId}`}
        className={`border-1 p-2 ${searchResult?.class} ${item.task.isSkipped ? "bg-red-100" : ""}`}
        target="_blank"
      >
        <i className="pi pi-external-link mr-2" />
        {`${item.task.isSkipped ? "(disabled) " : ""}${dagId} 🠶 ${taskId} [${searchResult?.label}]`}
      </Link>
    );
  };

  return (
    <>
      <InputLabelWrapper labelName="By product template" col={12}>
        <ProductTemplateMultiselect
          value={searchItems.templates}
          onChange={e => setSearchItems(prev => ({ ...prev, templates: e.value }))}
        />
      </InputLabelWrapper>
      <InputLabelWrapper labelName="By dataset" col={12}>
        <DatasetMultiSelect
          value={searchItems.datasets}
          onChange={datasets => setSearchItems(prev => ({ ...prev, datasets }))}
          proxied
        />
      </InputLabelWrapper>
      <div className="px-2">
        <ListBox
          options={data}
          optionLabel="resultFound"
          className="w-full my-3 h-25rem overflow-y-auto"
          listClassName="white-space-nowrap w-max"
          itemTemplate={itemTemplate}
          emptyMessage="No records found"
        />
      </div>
      <div className="flex justify-content-end gap-2 mx-2">
        <Button
          label={T("action.cancel")}
          className="p-button-sm p-button-outlined p-button-secondary"
          type="button"
          onClick={closeDialog}
        />
        <Button
          label={T("action.search")}
          onClick={onSubmit}
          className="p-button-sm p-button-success"
          loading={status === "pending"}
        />
      </div>
    </>
  );
};

export default SearchUsage;
